import { LegalLink, LegalSection, LegalShell, SupportContact } from "./LegalShell.js";
import { PLATFORM_MAILING_ADDRESS, useSite } from "./site.js";

/**
 * Support and contact (GH-812) — the page App Store Connect's support URL points at.
 *
 * The contact is the deployment's `SUPPORT_CONTACT` (the same value receipts print as "Questions
 * or a refund"), never a literal here.
 */
export function SupportPage() {
  const { organizationLegalName: entity, productName: product } = useSite();
  return (
    <LegalShell title="Support">
      <LegalSection id="contact" title="Contact us">
        <p>
          Email or call <SupportContact />. {product} is operated by {entity},{" "}
          {PLATFORM_MAILING_ADDRESS}. We answer email Monday to Friday and reply within two business
          days.
        </p>
      </LegalSection>

      <LegalSection id="gift" title="A question about a gift">
        <p>
          Tell us the date, the amount, and the organization, and the receipt number if you have it.
          Never send a full card number or a bank password — we will never ask for them.
        </p>
        <p>
          A charge you do not recognize, a duplicate, or a wrong amount can be corrected within 30
          days — see the{" "}
          <LegalLink to="terms" hash="refunds">
            refund policy
          </LegalLink>
          .
        </p>
      </LegalSection>

      <LegalSection id="account" title="Your account and your data">
        <p>
          <LegalLink to="accountDeletion">Delete your account or ask for your data</LegalLink>.
        </p>
      </LegalSection>

      <LegalSection id="organizations" title="For organizations">
        <p>
          To list or claim your organization, or to manage it, go to the{" "}
          <a href="/org">organization sign-up</a> or the <a href="/console">console</a>.
        </p>
      </LegalSection>

      <LegalSection id="policies" title="Policies">
        <ul>
          <li>
            <LegalLink to="terms">Terms of Use</LegalLink>
          </li>
          <li>
            <LegalLink to="privacy">Privacy Policy</LegalLink>
          </li>
          <li>
            <LegalLink to="disclosures">Donor disclosures</LegalLink>
          </li>
        </ul>
      </LegalSection>
    </LegalShell>
  );
}
